import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com';

if (POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: true,
    capture_pageview: true,
    persistence: 'localStorage+cookie',
    // Unhandled window errors and unhandled promise rejections → PostHog Error Tracking
    capture_exceptions: true,
    debug: process.env.NODE_ENV === 'development',
    loaded: (loadedPosthog) => {
      if (process.env.NODE_ENV === 'development') {
        loadedPosthog.debug();
      }
    },
  });
} else {
  console.warn('PostHog key not found. Usage monitoring disabled.');
}

export const identifyUser = (id, properties) => {
  if (POSTHOG_KEY) {
    posthog.identify(id, properties);
  }
};

export const resetUser = () => {
  if (POSTHOG_KEY) {
    posthog.reset();
  }
};

export const captureEvent = (eventName, properties) => {
  if (POSTHOG_KEY) {
    posthog.capture(eventName, properties);
  }
};

/** Report a caught error (e.g. React Error Boundary). No-op if PostHog is not configured. */
export const captureException = (error, properties = {}) => {
  if (!POSTHOG_KEY || typeof posthog.captureException !== 'function') {
    return;
  }
  posthog.captureException(error, properties);
};

export default posthog;
